<template>
  <b-popover
    ref="popover"
    :id="id"
    :target="target"
    :triggers="triggers"
    :custom-class="customClass"
    :placement="placement"
    :delay="{ show: showDelay, hide: hideDelay }"
    @shown="$emit('shown')"
    @hide="$emit('hide', $event)"
    :boundary="boundary"
    :no-fade="noFade"
  >
    <slot></slot>
  </b-popover>
</template>

<script>
import random from '@/utils/random'
import { BPopover } from 'bootstrap-vue'
/**
 * This is a wrapper over bootstrap popover
 */
export default {
  name: 'Popover',
  props: {
    triggers: {
      default: 'hover'
    },
    customClass: String,
    placement: {
      default: 'bottom'
    },
    boundary: {
      default: 'scrollParent'
    },
    target: String,
    showDelay: {
      default: 500,
      type: Number
    },
    hideDelay: {
      default: 500,
      type: Number
    },
    noFade: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BPopover
  },
  data() {
    return {
      id: random(6).toString()
    }
  },
  computed: {},
  methods: {
    close() {
      this.$refs.popover.$emit('close')
    },
    open() {
      this.$refs.popover.$emit('open')
    }
  },
  beforeDestroy() {
    this.$root.$emit('bv::popover::hidden', { vueTarget: this.$refs.popover })
  },
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
